import React from 'react';
import ProvidersPage from './Page.tsx';

import { loadProviders, loadStates } from '@/common/api';
import PageFade from '@/common/components/PageFade.tsx';

export const loader = async ({ request }: { request: Request }) => {
  const url = new URL(request.url);
  const stateCode = url.searchParams.get('state_code');
  const insuranceName = url.searchParams.get('insurance_company_name');

  const statesPromise = loadStates();

  if (stateCode && insuranceName) {
    const providersPromise = loadProviders(url.searchParams);
    const [providers, states] = await Promise.all([
      providersPromise,
      statesPromise,
    ]);

    return { providers, states };
  }

  const states = await statesPromise;
  return { providers: [], states };
};

const ProvidersRoute: React.FC = () => {
  return (
    <PageFade>
      <ProvidersPage />
    </PageFade>
  );
};

export default ProvidersRoute;
